export const categoryCodes = ({
  BROKER_BORROWER_ABOUT_APPRAISAL: "1",
  QA2_COMPLETED_ABOUT_APPRAISER: "2",
  QA2_RETURNED_ABOUT_APPRAISER: "3",
  APPRAISER_ABOUT_FIELDREP: "4",
  APPRAISER_ABOUT_OPS_MANAGER: "5",
  APPRAISER_ABOUT_TECHNOLOGY: "6",
  HOMEOWNER_ABOUT_TECHNOLOGY: "7",
});